import { Alert } from './ui'

/** Shown above the sign-in form when the API answered `403 step_up_required`. */
export function StepUpBanner({ returnTo }: { returnTo: string }) {
  return (
    <Alert tone="info">
      <strong>Confirm it&apos;s you.</strong> That action needs a recent sign-in. Sign in again and you&apos;ll be
      returned to <code className="text-xs">{returnTo}</code>.
    </Alert>
  )
}
